import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CoordinatesPipe } from './coordinates.pipe';
import { CoordinatesComponent } from './coordinates/coordinates.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  declarations: [CoordinatesPipe, CoordinatesComponent],
  exports: [CoordinatesPipe, CoordinatesComponent],
})
export class AmgGeoModule {}
